// Workspace context types for tracking loaded workspace state

export interface WorkspaceContext {
  currentWorkspace: {
    id: string | null; // Which workspace is loaded
    name: string | null; // Display name
    version: number | null; // Current version
    lastSaved: string | null; // When it was loaded
    hasUnsavedChanges: boolean; // Change tracking
  };
  isWorkspaceLoaded: boolean; // Quick boolean check
}

export interface WorkspaceContextActions {
  setWorkspaceContext: (context: WorkspaceContext) => void;
  markWorkspaceAsChanged: () => void;
  clearWorkspaceContext: () => void;
  updateWorkspaceAfterSave: (workspace: import('./workspace').Workspace) => void;
}

export const initialWorkspaceContext: WorkspaceContext = {
  currentWorkspace: {
    id: null,
    name: null,
    version: null,
    lastSaved: null,
    hasUnsavedChanges: false,
  },
  isWorkspaceLoaded: false,
};
